import React, { Component } from "react";
import Rightarow from "../images/service-arw.webp";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import { apiCallingPost } from "../services";
import moment from "moment";
import SaturdaySet from "./saturadySet";

class Servicestation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centersData: props.centersData || [],
      centersTotalCount: props.centersTotalCount || 0,
      pagesize: props.pagesize,
      offset: props.offset,
      activePage: props.activePage,
      itemsCountPerPage: props.itemsCountPerPage,
      currentTimeee: moment().format("HH:mm a"),
      isSpecialSaturday: false,
    };
  }

  handleSaturdaysUpdate = (saturdays) => {
    this.setState({ isSpecialSaturday: saturdays });
  };

  knowMore = (seoSlug) => {
    window.sessionStorage.setItem(
      "searchObjArray",
      JSON.stringify(this.props.dataPassing)
    );
  };

  render() {
    const { centersData, centersTotalCount, currentTimeee, isSpecialSaturday } =
      this.state;
    const { dataPassing } = this.props;

    const renderAddress = (address) => {
      const addressDetailsArray = address.split("|");
      // console.log("🚀 ~ Servicestation ~ renderAddress ~ address:", addressDetailsArray[5])
      return (
        <>
          <div className="servce-txt-sub">
            <div className="servce-left-txt">Address</div>
            <div className="servce-column">:</div>
            <div className="servce-sub-txt servce-addrs-txt">
              {addressDetailsArray[2]}
            </div>
          </div>
          {addressDetailsArray[3] && (
            <div className="servce-txt-sub">
              <div className="servce-left-txt">Landmark</div>
              <div className="servce-column">:</div>
              <div className="servce-sub-txt servce-addrs-txt">
                {addressDetailsArray[3]}
              </div>
            </div>
          )}
          <div className="servce-txt-sub">
            <div className="servce-left-txt">Contact Number</div>
            <div className="servce-column">:</div>
            <div className="servce-sub-txt servce-addrs-txt cursor-pointer">
              <a
                className="servce-addrsPhone"
                href={"tel:" + addressDetailsArray[5]}
              >
                {addressDetailsArray[5]}
              </a>
            </div>
          </div>
        </>
      );
    };

    const renderHours = (data) => {
      const businessHour = data.customBusinessHour?.split("|") || [];
      const openTime = moment(businessHour[2], 'hh:mm A').format('HH:mm');
      const closeTime = moment(businessHour[3], 'hh:mm A').format('HH:mm');    
      if (data.customBusinessHour === "Open 24 hours") {
        return data.customBusinessHour;
      }
      if ((isSpecialSaturday && (data.category !== "ATM" || data.category !== "CDM")) || (moment().day() === 7) || (currentTimeee > closeTime)) {
        return <span className="text-danger">Closed for the day</span>;
      }
      if (currentTimeee < openTime) {
        return `Will open at ${openTime}`;
      } else if (currentTimeee > openTime && currentTimeee < closeTime) {
        return `Open until ${moment(closeTime, "HH:mm").format("hh:mm A")}`;
      } 
      return <span className="text-danger"></span>;
    };

    return (
      <div className="outer-padng service-page">
        <SaturdaySet onSaturdaysUpdate={this.handleSaturdaysUpdate} />
        {centersTotalCount > 0 && (
          <>
            <h1 className="main-head">
    {"AXIS BANK "}
    {this.props.dataPassing[8].searchValueSet ? (
      <span>Branches/ATMs In {this.props.dataPassing[8].searchValueSet}</span>
    ) : (
      <>
        {this.props.dataPassing[0].stateValueSet &&
          !this.props.dataPassing[2].locationSet &&
          !this.props.dataPassing[1].citySet && (
            <span>Branches/ATMs In {this.props.dataPassing[0].stateValueSet}</span>
          )}
        {this.props.dataPassing[2].locationSet &&
          this.props.dataPassing[1].citySet && (
            <span>
              Branches/ATMs In {this.props.dataPassing[2].locationSet},&nbsp;
              {this.props.dataPassing[1].citySet},&nbsp;
              {this.props.dataPassing[0].stateValueSet}
            </span>
          )}
      </>
    )}
  </h1>
            <div className="row service-stations m-0" id="service-station">
              {centersData.map((data, i) => (
                <div className="col-lg-4 store-list-sub-main" key={i}>
                  <div className="store-list-sub">
                    <div
                      className="service-station-subhead"
                      value={data.dealerName}
                      title={`AXIS BANK - ${data.location}, ${data.City}`}
                    >
                    {data.dealerName?.replace(/(Branch|ATM)(\s)/, '$1,$2')}
                    </div>
                    {data.ifscCode && (
                      <div className="servce-txt-sub">
                        <div className="servce-left-txt">IFSC</div>
                        <div className="servce-column">:</div>
                        <div className="servce-sub-txt servce-addrs-txt">
                          {data.ifscCode}
                        </div>
                      </div>
                    )}
                    <div className="servce-txt-sub">
                      <div className="servce-left-txt">State</div>
                      <div className="servce-column">:</div>
                      <div className="servce-sub-txt servce-addrs-txt">
                        {data.State}
                      </div>
                    </div>
                    <div className="servce-txt-sub">
                      <div className="servce-left-txt">City</div>
                      <div className="servce-column">:</div>
                      <div className="servce-sub-txt servce-addrs-txt">
                        {data.City}
                      </div>
                    </div>
                    {renderAddress(data.newAddress)}
                    <div className="servce-txt-sub">
                      <div className="servce-left-txt">Hours</div>
                      <div className="servce-column">:</div>
                      <div className="servce-sub-txt servce-addrs-txt">
                        {renderHours(data)}
                      </div>
                    </div>
                    <div className="servce-txt-sub">
                      <div className="servce-left-txt">Pincode</div>
                      <div className="servce-column">:</div>
                      <div className="servce-sub-txt servce-addrs-txt">
                        {data.pin_code}
                      </div>
                    </div>
                    <div className="servce-txt-sub">
                      <a
                        href={`/${data.seoSlug.replaceAll(" ", "-")}/Home`}
                        onClick={() => this.knowMore(data.seoSlug)}
                        className="servce-sub-txt service-arwbtm-div text-dec-none search_knoemorebtn"
                        style={{ paddingRight: "0", width: "auto" }}
                      >
                        know more
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {centersTotalCount > 3 && (
          <div className="pagination-web">
            <div className="pagination-service-section">
              <Pagination
                activePage={this.state.activePage}
                itemsCountPerPage={this.state.itemsCountPerPage}
                totalItemsCount={centersTotalCount}
                pageRangeDisplayed={5}
                onChange={this.props.handlePageChange}
                prevPageText=" ← Prev"
                nextPageText="Next →"
              />
            </div>
          </div>
        )}
        {centersTotalCount > 3 && (
          <div className="pagination-mob">
            <div className="pagination-service-section">
              <Pagination
                activePage={this.state.activePage}
                itemsCountPerPage={this.state.itemsCountPerPage}
                totalItemsCount={centersTotalCount}
                pageRangeDisplayed={2}
                onChange={this.props.handlePageChange}
                prevPageText=" ←"
                nextPageText="→"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Servicestation;
